import type { AnimationProperties, AnimationsKit } from '../../../types';

const name = 'HeaderFadeOutCustom';
const properties: AnimationProperties = {
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
  },
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  { ease = 'Quart.easeIn', ...params },
) {
  const sequence = kit.sequence(params);

  const animationParams = {
    ease,
    to: { autoAlpha: 0 },
  };

  sequence.add(
    kit.animate('BaseFade', elements, duration, delay, animationParams),
  );
  return sequence.get();
}

export { name, properties, animate };
